import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { merge, Observable, of } from 'rxjs';
import { delay, map, switchMap } from 'rxjs/operators';
import { IDataTableRowActionClickArg } from 'src/app/share/components/data-table-card/data-table-card.component';
import { IRowViewModel, IViewData } from 'src/app/share/entities/view-model';
import { FormAutoCompleteComponent, IFormAutoCompleteViewModel } from 'src/app/share/forms/form-auto-complete/form-auto-complete.component';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { FormOkCancelComponent } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';
import { BasePageComponent, IBasePageOnInitArg, IDataPanelTabViewModel, IWorkflowCompleteFormViewModel } from 'src/app/share/pages/base-page.component';
import { IPageContentFormViewModel, IPageContentViewModel, IPageDataViewModel, IPageViewModel } from 'src/app/share/pages/pages';
import { CommonService } from 'src/app/share/services/common.service';
import { ShellService } from 'src/app/shell/shell.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { DateUtil } from 'src/app/share/utils/date-util';

@Component({
  templateUrl: './wwe-manifest-page.component.html',
  styleUrls: ['./wwe-manifest-page.component.scss']
})
export class WweManifestPageComponent extends BasePageComponent implements OnInit {

  /**
   * todo.... rework component for generic Customer Manifest processing
   */
  private readonly apiPath: string = '/api/reservations';

  /**
   * 
   */
  constructor(private apiService: CommonService, protected shellService: ShellService, protected activatedRate: ActivatedRoute) {
    super(shellService, activatedRate);
  }


  /**
   * 
   * @param action 
   * @param paramData 
   * @returns 
   */
  private commandInvoke(action: string, paramData): Observable<IPageDataViewModel> {
    return this.apiService.getData('PageCommand', 'wwe-manifest', action, paramData, this.apiPath, true);
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   */
  onPageAddNew(pvm: IPageViewModel, vm: IContentViewModel) {
    this.handleUploadFormStart(pvm, vm);
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  async handleFormOk(pvm: IPageViewModel, vm: IContentViewModel, fvm: IPageContentFormViewModel) {
    const success = await (
      fvm.type == 'handle-upload' ? this.handleUploadFormOkAsync(pvm, vm, <IHandleUploadFormViewMomdel>fvm)
        : fvm.type == 'handle-accept' ? this.handleAcceptFormOkAsync(pvm, vm, <IHandleAcceptFormViewModel>fvm)
          : of(true).toPromise()
    );

    if (success)
      this.formEndRefresh(pvm);
  }

  /**
    * 
    * @returns 
    */
  private fieldItemViewDefs(): { fieldName: string, title: string }[] {
    const ret: { fieldName: string, title: string }[] = [
      { fieldName: 'resNumberWwe', title: 'Res Number (WWE)' },
      { fieldName: 'resNumberSc', title: 'Res Number (ECLS)' },

      { fieldName: 'requestedBy', title: 'Requested By' },
      { fieldName: 'leadPassengerName', title: 'Lead Passenger' },
      { fieldName: 'typeOfRequest', title: 'Type of Request' },
      { fieldName: 'status', title: 'Status' },

      { fieldName: 'pickupDate', title: 'Pickup Date' },
      { fieldName: 'pickupTime', title: 'Pickup Time' },
      { fieldName: 'vehicle', title: 'Vehicle' },
      { fieldName: 'numberOfPax', title: 'Number of Pax' },

      { fieldName: 'pickupAddress', title: 'Pickup Address' },
      { fieldName: 'otherLocationFrom', title: 'Other Location From' },
      { fieldName: 'finalDropOffAddress', title: 'Final Drop Off Address' },
      { fieldName: 'otherLocationTo', title: 'Other Location To' },
      { fieldName: 'airline', title: 'Airline' },
      { fieldName: 'flightNumber', title: 'Flight Number' },
      { fieldName: 'stop1', title: 'Stop 1' },
      { fieldName: 'stop2', title: 'Stop 2' },
      { fieldName: 'stop3', title: 'Stop 3' },
      { fieldName: 'stop4', title: 'Stop 4' },
      { fieldName: 'stop5', title: 'Stop 5' },

      { fieldName: 'waitDurationHours', title: 'Wait Duration Hours' },
      { fieldName: 'waitAndReturn', title: 'Wait and Return' },
      { fieldName: 'specialDropOffPickupInstructions', title: 'Spcial Instructions' },
      { fieldName: 'departmentChanged', title: 'Department Changed' }
    ];
    return ret;
  }

  //#region handle upload form

  /**
   * 
   * @param pvm 
   * @param vm 
   */
  private async handleUploadFormStart(pvm: IPageViewModel, vm: IContentViewModel) {
    const fvm = super.formBegin(pvm, this.handleUploadFormVm(vm));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* todo... implement work */
      );
    });
  }

  /**
   * 
   * @param vm 
   * @returns 
   */
  private handleUploadFormVm(vm: IContentViewModel): IHandleUploadFormViewMomdel {
    const data = { text: '' };

    const ret: IHandleUploadFormViewMomdel = {
      ...super.formVm('handle-upload', { okCancelOptions: {} }),

      title: 'Upload Manifest',
      data: data,

      textInputVm: FormInputComponent.viewModel(data, 'text', { title: 'Text', type: 'textarea', isRequired: true })
    };
    return ret;
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  private async handleUploadFormOkAsync(pvm: IPageViewModel, vm: IContentViewModel, fvm: IHandleUploadFormViewMomdel): Promise<boolean> {
    const lines = fvm.data.text.split('\n').filter(l => l);

    const items: IManifestItem[] = lines.map(l => {
      const fields = l.split('\t');
      let fdx = 0;

      const item: IManifestItem = {
        resNumberWwe: fields[fdx++],
        requestedBy: fields[fdx++],
        leadPassengerName: fields[fdx++],
        typeOfRequest: fields[fdx++],
        status: fields[fdx++],

        pickupDate: fields[fdx++],
        pickupTime: fields[fdx++],
        vehicle: fields[fdx++],
        numberOfPax: fields[fdx++],

        pickupAddress: fields[fdx++],
        otherLocationFrom: fields[fdx++],
        finalDropOffAddress: fields[fdx++],
        otherLocationTo: fields[fdx++],
        airline: fields[fdx++],
        flightNumber: fields[fdx++],
        stop1: fields[fdx++],
        stop2: fields[fdx++],
        stop3: fields[fdx++],
        stop4: fields[fdx++],
        stop5: fields[fdx++],

        waitDurationHours: fields[fdx++],
        waitAndReturn: fields[fdx++],
        specialDropOffPickupInstructions: fields[fdx++],
        departmentChanged: fields[fdx++]
      };
      return item;
    });

    const paramData = { upload: { items: items } };

    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Uploading...',
      () => this.commandInvoke('handle-upload', paramData));
    return success;
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  handleUploadFormValidate(pvm: IPageViewModel, vm: IContentViewModel, fvm: IHandleUploadFormViewMomdel) {
    fvm.isValid = (fvm.data.text ?? '').length > 0;
  }


  //#endregion handle upload form

  //#region handle accept form

  /**
   * 
   */
  private async handleAcceptFormStart(pvm: IPageViewModel, vm: IContentViewModel, itemData: IManifestItemData) {
    const fvm = super.formBegin(pvm, this.handleAcceptFormVm(pvm, vm, itemData));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* todo... implement work */
      );
    });
  }

  /**
   * 
   * @param pvm
   * @param vm 
   * @param itemData
   * @returns 
   */
  private handleAcceptFormVm(pvm: IPageViewModel, vm: IContentViewModel, itemData: IManifestItemData): IHandleAcceptFormViewModel {
    const data = { resNumberWwe: itemData.data.resNumberWwe, resNumberSc: itemData.data.resNumberSc ?? '', notes: '' };

    const changeSets = (itemData.data.changeTracking?.changeSets ?? []).filter(cs => cs.processedByUser == undefined);

    const fieldItems: IFieldViewModel[] = this.fieldItemViewDefs().map(d => {
      const previousValues: string[] = changeSets.reduce((pv, cv) => {
        const change = cv.changes.find(c => c.fieldName.toUpperCase() == d.fieldName.toUpperCase())?.beforeValue;
        if (!change)
          return [...pv];
        else
          return [
            ...pv, change
          ];
      }, []);
      const ret: IFieldViewModel = { title: d.title, value: itemData.data[d.fieldName], previousValues: previousValues };
      return ret;
    });

    const ret: IHandleAcceptFormViewModel = {
      ...super.formVm('handle-accept', { okCancelOptions: { okText: 'Accept' } }),
      title: 'Accept',

      itemData: itemData,
      data: data,

      resNumberInputVm: itemData.changeType == 'new' ? FormInputComponent.viewModel(data, 'resNumberSc', { title: 'SC Res Number', isRequired: true, minLength: 6 }) : undefined,
      notesInputVm: FormInputComponent.viewModel(data, 'notes', { title: 'Notes', type: 'textarea', isRequired: false }),

      fieldItemDisplayVm: {
        showPrevious: changeSets.length > 0,
        fieldItemVms: fieldItems
      }
    };

    this.handleAcceptFormValidate(pvm, vm, ret);

    return ret;
  }

  /**
   * 
   * @param pvm
   * @param vm 
   * @param fvm 
   */
  handleAcceptFormValidate(pvm: IPageViewModel, vm: IContentViewModel, fvm: IHandleAcceptFormViewModel) {
    const valids = [      
      !(fvm.data.resNumberSc ?? '').includes('*') ? false : true
    ];
    fvm.isValid = valids.filter(v => !v).length == 0;
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  private async handleAcceptFormOkAsync(pvm: IPageViewModel, vm: IContentViewModel, fvm: IHandleAcceptFormViewModel): Promise<boolean> {
    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Accepting...',
      () => this.commandInvoke('handle-accept', { accept: fvm.data }));
    return success;
  }

  //#endregion handle accept form

  //#region handle view form

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param itemData 
   */
  private async handleViewFormStart(pvm: IPageViewModel, vm: IContentViewModel, itemData: IManifestItemData) {
    const fvm = super.formBegin(pvm, this.handleViewFormVm(pvm, vm, itemData));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* todo... implement work */
      );
    });
  }

  /**
     * 
     * @param pvm
     * @param vm 
     * @param itemData
     * @returns 
     */
  private handleViewFormVm(pvm: IPageViewModel, vm: IContentViewModel, itemData: IManifestItemData): IHandleViewFormViewModel {
    const fieldItems: IFieldViewModel[] = this.fieldItemViewDefs().map(d => ({ title: d.title, value: itemData.data[d.fieldName], previousValues: [] }));

    const ret: IHandleViewFormViewModel = {
      ...super.formVm('handle-view', { okCancelOptions: { okText: 'Ok' } }),
      title: 'View', isValid: true,

      itemData: itemData,

      fieldItemDisplayVm: {
        showPrevious: false,
        fieldItemVms: fieldItems
      }
    };
    return ret;
  }

  //#endregion handle view form

  /**
   * 
   */
  ngOnInit(): void {
    super.onInit((arg: IBasePageOnInitArg) => {

      // user page
      return of({}).pipe(

        // load content VM
        switchMap(() => this.commandInvoke('page-load', {})),

        // return page VM
        map((pd: IPageDataViewModel) => {
          if (pd.workingText || pd.errorText)
            return pd;

          const ret: IPageDataViewModel = {
            ...pd,

            contentVm: this.contentViewModel(arg, pd.data)
          };
          return ret;
        })
      );
    }, { canRefresh: true, canAddNew: true, canGoBack: true });
  }

  /**
   * 
   * @param pvm 
   * @param vm
   * @param tvm
   * @param arg 
   */
  rowActionInvoke(pvm: IPageViewModel, vm: IContentViewModel, tvm: IDataPanelTabViewModel, arg: IDataTableRowActionClickArg) {
    if (arg.actionCode == 'handle-accept') {
      const data = vm.data.items.find(i => i.data.resNumberWwe == arg.rowCode);
      this.handleAcceptFormStart(pvm, vm, data);

    } else if (arg.actionCode == 'handle-view') {
      const data = vm.data.items.find(i => i.data.resNumberWwe == arg.rowCode);
      this.handleViewFormStart(pvm, vm, data);
    }
  }

  /**
   * 
   * @param arg 
   * @param data
   * @returns 
   */
  private contentViewModel(arg: IBasePageOnInitArg, data: { items: IManifestItemData[] }): IContentViewModel {
    // changed rows, must accept
    const changeRows: IRowViewModel[] = data.items.filter(i => i.changeType != 'none').map(i => {
      return {
        code: i.data.resNumberWwe,
        fields: [
          i.changeType == 'changed' ? 'Changed' : i.changeType == 'new' ? 'New' : 'Unknown',
          i.data.leadPassengerName,
          DateUtil.shortDateTimeLocal(DateUtil.Parse(i.pickupDateTimeString)),
          i.data.pickupAddress, i.data.vehicle
        ],
        actions: [
          ...i.actionType.actions
        ]
      };
    });

    // active rows, can view
    const activeRows: IRowViewModel[] = data.items.filter(i => i.changeType == 'none').map(i => {
      return {
        code: i.data.resNumberWwe,
        fields: [
          i.data.leadPassengerName,
          DateUtil.shortDateTimeLocal(DateUtil.Parse(i.pickupDateTimeString)),
          i.data.pickupAddress, i.data.vehicle
        ],
        actions: [
          ...i.actionType.actions
        ]
      };
    });


    // view model
    const vm: IContentViewModel = {
      data: data,

      tabVms: [
        {
          title: 'Changes',
          dataPanelVm: {
            data: {
              unauthorized: false,
              title: 'test',
              columns: [
                'ChangeType', 'Passenger',
                'Date / Time', 'Address', 'Vehicle'
              ],
              rows: [
                []
              ],
              styleTypes: []
            },
            rows: changeRows,
            rowsFiltered: [...changeRows]
          }
        },
        {
          title: 'Active',
          dataPanelVm: {
            data: {
              unauthorized: false,
              title: 'test',
              columns: [
                'Passenger',
                'Date / Time', 'Address', 'Vehicle'
              ],
              rows: [
                []
              ],
              styleTypes: []
            },
            rows: activeRows,
            rowsFiltered: [...activeRows]
          }
        }
      ]
    };
    return vm;
  }

}

/**
 * 
 */
interface IContentViewModel extends IPageContentViewModel {
  data: {
    items: IManifestItemData[];
  };

  tabVms?: IDataPanelTabViewModel[];
}

/**
 * 
 */
interface IHandleAcceptFormViewModel extends IPageContentFormViewModel {
  itemData: IManifestItemData;

  data: {
    resNumberSc: string;
    resNumberWwe: string;
    notes: string;
  };

  resNumberInputVm?: IFormInputViewModel;
  notesInputVm: IFormInputViewModel;

  fieldItemDisplayVm: IFieldItemDisplayViewModel;
}

/**
 * 
 */
interface IFieldItemDisplayViewModel {
  showPrevious: boolean;
  fieldItemVms: IFieldViewModel[];
}

/**
 * 
 */
interface IFieldViewModel {
  title: string;
  value: string;
  
  previousValues: string[];
}

/**
 * 
 */
interface IHandleUploadFormViewMomdel extends IPageContentFormViewModel {
  data: {
    text: string;
  }

  textInputVm: IFormInputViewModel;
}

/**
 * 
 */
interface IHandleViewFormViewModel extends IPageContentFormViewModel {
  itemData: IManifestItemData;

  fieldItemDisplayVm: IFieldItemDisplayViewModel;
}

/**
 * 
 */
interface IManifestItemData {
  data: IManifestItem;

  pickupDateTimeString: string;
  changeType: 'new' | 'changed' | 'none';

  actionType: {
    entityCode: string;
    actions: { code: string, name: string }[];
  }
}

/**
 * 
 */
interface IManifestItem {
  resNumberSc?: string;

  resNumberWwe: string;

  requestedBy: string;
  leadPassengerName: string;
  typeOfRequest: string;
  status: string;

  pickupDate: string;
  pickupTime: string;
  vehicle: string;
  numberOfPax: string;

  pickupAddress: string;
  otherLocationFrom: string;
  finalDropOffAddress: string;
  otherLocationTo: string;
  airline: string;
  flightNumber: string;
  stop1: string;
  stop2: string;
  stop3: string;
  stop4: string;
  stop5: string;

  waitDurationHours: string;
  waitAndReturn: string;
  specialDropOffPickupInstructions: string;
  departmentChanged: string;

  changeTracking?: IManifestItemChangeTracking;
}

/**
 * 
 */
interface IManifestItemChangeTracking {
  isNew: boolean;
  isModified: boolean;

  changeSets: IManifestItemChangeSet[];
}

/**
 * 
 */
interface IManifestItemChangeSet {
  changedDateTime: string;

  changes: IManifestItemChange[];

  processedByUser: string;
  processedByDateTime: string;
  processedByNotes: string;
}

/**
 * 
 */
interface IManifestItemChange {
  fieldName: string;
  beforeValue: string;
  afterValue: string;
}

